import { SvgIcon, SvgIconProps } from '@mui/material';

const ManageIcon = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_16036_102)">
      <mask
        id="mask0_16036_102"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_16036_102)">
        <path
          d="M10.0039 3.5C10.28 3.5 10.5039 3.72386 10.5039 4V5.5H12.5039V4C12.5039 3.72386 12.7278 3.5 13.0039 3.5H19.0039C19.28 3.5 19.5039 3.72386 19.5039 4V5.5H20.0039L20.1064 5.50488C20.6106 5.55621 21.0039 5.98232 21.0039 6.5V10.3379C20.5333 10.0845 20.0305 9.88416 19.5039 9.74121V7H3.50391V19H10.9355C11.1257 19.5323 11.3778 20.0348 11.6826 20.5H3.00391L2.90137 20.4951C2.43094 20.4472 2.05669 20.073 2.00879 19.6025L2.00391 19.5V6.5C2.00391 5.98232 2.39724 5.55621 2.90137 5.50488L3.00391 5.5H3.50391V4C3.50391 3.72386 3.72776 3.5 4.00391 3.5H10.0039Z"
          fill="currentColor"
        />
        <path
          d="M18.7422 13.0981C19.0777 13.1947 19.3677 13.3159 19.6113 13.4614C19.8549 13.6071 20.0886 13.7833 20.3115 13.9897L21.6123 13.4888L22.5264 14.9858L21.4678 15.8999C21.5585 16.2564 21.6045 16.5787 21.6045 16.8667C21.6045 17.1549 21.5585 17.4777 21.4678 17.8345L22.5264 18.7476L21.6123 20.2446L20.3115 19.7612C20.0886 19.9677 19.8549 20.1439 19.6113 20.2896C19.3676 20.4351 19.0777 20.5563 18.7422 20.6528L18.5059 22.0239H16.7676L16.5322 20.6528C16.1966 20.5563 15.9068 20.4351 15.6631 20.2896C15.4193 20.1439 15.1856 19.9677 14.9629 19.7612L13.6611 20.2632L12.748 18.7651L13.8066 17.8521C13.7161 17.4957 13.6709 17.1733 13.6709 16.8853C13.6709 16.5969 13.7161 16.274 13.8066 15.9175L12.748 15.0034L13.6611 13.5063L14.9629 14.0073C15.1856 13.8009 15.4194 13.6218 15.6631 13.4702C15.9067 13.3187 16.1967 13.1947 16.5322 13.0981L16.7676 11.728H18.5059L18.7422 13.0981ZM17.6387 15.1938C16.7096 15.1938 15.9561 15.9474 15.9561 16.8765C15.9564 17.8053 16.7098 18.5581 17.6387 18.5581C18.5674 18.5579 19.32 17.8052 19.3203 16.8765C19.3203 15.9475 18.5676 15.194 17.6387 15.1938Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_16036_102">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default ManageIcon;
